import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const COLORS = [
  '#667eea', // Primary blue
  '#764ba2', // Purple
  '#f093fb', // Pink
  '#f5576c', // Red
  '#4facfe', // Light blue
  '#00f2fe', // Cyan
  '#43e97b'  // Green
];

function InvestmentPieChart({ data }) {
  const sortedData = Object.entries(data)
    .sort(([, a], [, b]) => b - a)
    .map(([name, value]) => ({ name, value }));

  if (sortedData.length === 0) return null;

  return (
    <ResponsiveContainer width="100%" height={380}>
      <PieChart>
        <Pie
          data={sortedData}
          cx="50%"
          cy="45%"
          labelLine={false}
          outerRadius="60%"
          fill="#8884d8"
          dataKey="value"
        >
          {sortedData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          formatter={(value) => `€${Math.round(value).toLocaleString()}`}
          labelFormatter={(name) => `${name}`}
        />
        <Legend layout="horizontal" verticalAlign="bottom" align="center" />
      </PieChart>
    </ResponsiveContainer>
  );
}

export default InvestmentPieChart;
